import {decorate, observable, action} from "mobx"

export class ModalStore {
  isOpen = false
  setIsOpen(bool) {
    this.isOpen = bool
  }
}

decorate(ModalStore, {
  isOpen: observable,
  setIsOpen: action,
})
